<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-skeleton-loader v-if="$store.state.suppliers.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{ name: 'BillersBuiltInSettings' }" class="subtitle-1 routerLink font-weight-medium">Facturación incorporada</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
            Proveedores
          </v-toolbar-title>
          <v-spacer />
           <v-toolbar-items>
            <v-row align="center" justify="end" class="mr-1">
              <v-query-builder :query-map="filters" model="customer" class="mr-1" />
              <v-btn @click="dialogSupplier=true" color="secondary" outlined><v-icon left small>mdi-plus</v-icon>Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-skeleton-loader v-if="$store.state.suppliers.retrieveLoader" transition="fade-transition" type="table" />
          <template v-else>
            <template v-if="suppliersList.length">
              <v-data-table :headers="headers" :items="suppliersList" :items-per-page="pagination" mobile-breakpoint hide-default-header disable-sort hide-default-footer @click:row="(suppliersList) => {$router.push({name: 'SupplierRetrieveUpdate', params: {id: suppliersList.id}})}" style="cursor: pointer">
                <!-- header -->
                <template v-slot:header="{ props: { headers } }">
                  <VTableHeaders :headers="headers" @sort="setSort" />
                </template>
                <!-- end header -->
                <template v-slot:[`item.name`]="{item}">
                  <span class="text--secondary font-weight-medium">{{item.name}}</span>
                </template>
                <template v-slot:[`item.email`]="{item}">
                  {{item.email}}
                </template>
                <template v-slot:[`item.created`]="{item}">
                  <span class="text-right">{{item.created | date}}</span>
                </template>
              </v-data-table>
              <template v-if="showPagination || showAll">
                <v-divider />
                <v-row class="mx-0" align="center">
                  <v-col cols="12" class="text-center" v-if="showAll">
                    <v-btn :to="{name: 'SupplierListCreate', query: showCriteria}" outlined color="secondary">Ver todos los proveedores</v-btn>
                  </v-col>
                  <template v-if="showPagination">
                    <v-col cols="6">
                      <span class="body-2 text--secondary">{{count}} registros</span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <v-pagination v-model="page" :length="totalPages" total-visible="6"></v-pagination>
                    </v-col>
                  </template>
                </v-row>
              </template>
            </template>
            <v-row v-else>
              <v-col class="pb-6 pt-4 text-center">
                <v-icon class="d-block" color="secondary" size="70">mdi-badge-account-horizontal</v-icon>
                <span class="d-block subtitle-1 my-2">Aún no tienes proveedores registrados</span>
                <v-btn @click="dialogSupplier=true" outlined>Crear un proveedor</v-btn>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog new supplier -->
    <v-dialog v-model="dialogSupplier" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Crear proveedor</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogSupplier=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.newSupplier.name.$model" :error="$v.newSupplier.name.$error" background-color="white" outlined required single-line dense placeholder="Acme LLC" maxlength="100" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>País</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-select v-model="$v.newSupplier.country.$model" :error="$v.newSupplier.country.$error" single-line :items="countriesList" item-text="name" item-value="id" hide-details dense height="30" outlined background-color="white" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Estado</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-select v-model="$v.newSupplier.state.$model" :error="$v.newSupplier.state.$error" :items="statesList" item-text="name" item-value="id" single-line hide-details dense height="30" outlined background-color="white" no-data-text="No existen estados para el país." />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Dirección</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model.trim="$v.newSupplier.address.$model" :error="$v.newSupplier.address.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="mt-4">
              <v-list-item-title>
                <span class="text--secondary font-weight-medium">Información de facturación</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="mt-2">
              <v-list-item-title>
                Moneda de facturación y cobro
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>No podrás cambiar la moneda una vez que se guarde la información del cliente o se cree una factura del cliente.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-select v-model="$v.newSupplier.currency.$model" :error="$v.newSupplier.currency.$error" label="Elige una moneda" :items="currencies.filter(c => !c.conversion)" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" outlined dense single-line hide-details>
                    <template v-slot:item="data">
                      <v-list-item-title class="font-weight-regular">{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                    </template>
                  </v-select>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="mt-2">
              <v-list-item-title>
                ID Fiscal
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>También llamado RUT, VAT o Tax ID</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.newSupplier.tax_id.$model" :error="$v.newSupplier.tax_id.$error" v-dni="newSupplier.country" background-color="white" outlined single-line dense hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="country && country.id === 'CL'">
              <v-list-item-title>Actividad</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-text-field v-model.trim="$v.newSupplier.tax_settings.cl_activity_description.$model" :error="$v.newSupplier.tax_settings.cl_activity_description.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="mt-4">
              <v-list-item-title>
                <span class="text--secondary font-weight-medium">Información de contacto</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="mt-2">
              <v-list-item-title>Email de facturación</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.newSupplier.email.$model" :error="$v.newSupplier.email.$error" outlined required single-line background-color="white" dense maxlength="64" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Teléfono</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.newSupplier.phone.$model" :error="$v.newSupplier.phone.$error" background-color="white" outlined required single-line dense v-if="country" v-mask="`${country.phone_code} # #### ####`" maxlength="16" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Sitio web</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.newSupplier.website.$model" :error="$v.newSupplier.website.$error" background-color="white" outlined required single-line class="pa-0" dense  maxlength="64" :hide-details="true" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer/>
          <v-btn outlined @click="dialogSupplier=false">Cancelar</v-btn>
          <v-btn color="primary" :loading="$store.state.suppliers.createLoader" @click="postSupplier">Crear proveedor</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog new supplier -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength, email, url, requiredIf } from 'vuelidate/lib/validators'
import { rutValidator } from 'vue-dni'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  components: {
    VQueryBuilder,
    VTableHeaders,
    GenericViewMixin
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
      newSupplier: {
        name: '',
        tax_id: '',
        tax_settings: {
          cl_activity_description: ''
        },
        country: null,
        currency: null,
        state: '',
        address: '',
        email: '',
        phone: '',
        website: ''
      },
      filters: [
        {
          type: 'text',
          id: 'name',
          label: 'Nombre',
          operators: ['contiene']
        },
        {
          type: 'text',
          id: 'tax_id',
          label: 'Número fiscal',
          operators: ['contiene']
        },
        {
          type: 'text',
          id: 'created',
          label: 'Fecha de creación',
          operators: ['es igual', 'es menor a', 'es mayor a']
        },
        {
          type: 'radio',
          id: 'sources',
          label: 'Método de pago',
          choices: [{label: 'Si', value: 'True'}, {label: 'No', value: 'False'}]
        },
        {
          type: 'text',
          id: 'email',
          label: 'Email',
          operators: ['contiene']
        },
        {
          type: 'text',
          id: 'country__name',
          label: 'País',
          operators: ['contiene']
        }
      ],
       headers: [
        { text: 'Proveedor', value: 'name', class: 'font-weight-bold', sortable: true },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Creado el', value: 'created', align: 'end', sortable: true }
      ],
      statesList: {},
      dialogSupplier: false
  }),
  computed: {
    ...mapState({
      count: state => state.suppliers.suppliersCount,
      suppliersList: state => state.suppliers.suppliersList,
      countriesList: state => state.generals.countriesList
    }),
    country () {
      return this.newSupplier.country ? this.countriesList.find(country => country.id === this.newSupplier.country) : null
    }
  },
  created () {
    const query = {
      page_size: 100
    }
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/countries',
      query: query
    })
    .then(() => {
      const country = this.countriesList.filter(country => country.id === this.$store.state.auth.account.country.id)[0]
      this.newSupplier.country = country.id
    })
  },
  watch: {
    'newSupplier.country' () {
      this.statesList = this.countriesList.find(country => country.id === this.newSupplier.country).states
      this.newSupplier.state = ''
      this.newSupplier.tax_id = ''
    }
  },
  methods: {
    getList () {
      this.$store.dispatch('suppliers/LIST', {
        resource: 'suppliers',
        query: this.$route.query
      })
    },
    postSupplier () {
      this.$v.newSupplier.$touch()
      if (this.$v.newSupplier.$invalid) {
        return false
      }
      this.$store.dispatch('suppliers/CREATE', {
        resource: 'suppliers',
        payload: this.newSupplier
      })
      .then((response) => {
        this.$router.push({ name: 'SupplierRetrieveUpdate', params: { id: response.data.id } })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    newSupplier: {
      address: {
        required,
        maxLength: maxLength(64)
      },
      country: {
        required
      },
      currency: {
        required
      },
      email: {
        required,
        email,
        maxLength: maxLength(254)
      },
      name: {
        required,
        maxLength: maxLength(100)
      },
      phone: {
        maxLength: maxLength(16)
      },
      state: {
        required
      },
      tax_id: {
        required: requiredIf(function () {
          return this.countriesList.find(country => country.id === this.newSupplier.country).has_regulation
        }),
        taxId: function (val) {
          if (this.newSupplier.country === 'CL') {
            return rutValidator(val)
          }
          return true
        },
        maxLength: maxLength(32)
      },
      tax_settings: {
        cl_activity_description: {
          required: requiredIf(function () {
            return this.newSupplier.country === 'CL'
          }),
          maxLength: maxLength(64)
        }
      },
      website: {
        url
      }
    }
  }
}
</script>